import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDXpJPVKepT1YpgVHSqndLGKBm6yWl0yFc",
  authDomain: "save-oom-oxna.firebaseapp.com",
  projectId: "save-oom-oxna",
  storageBucket: "save-oom-oxna.appspot.com",
  messagingSenderId: "323575125763",
  appId: "1:323575125763:web:0261a180e32421b9663b36",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// get auth and firestore
export const auth = getAuth(app);
export const db = getFirestore(app);
